import { DirectoryColumnTypesRealTimeData } from 'src/generated/signalR/directory-column-types-real-time-data';

export class DirectoryHelperEntrySelected {
   public static readonly type = '[Directory Helper] Entry Selected';

   constructor(public brickInstanceId: string, public directoryEntryId: number) {}
}

export class DirectoryColumnTypes {
   public static readonly type = '[Selected Subscriber] Directory Column Types';

   constructor(public directoryColumns: DirectoryColumnTypesRealTimeData) {}
}
